export default "__VITE_ASSET__CvqnxBuG__"